<div class="flex flex-col gap-2">
  <div>
    <h3 class="font-semibold text-[15px] leading-[19px] text-[var(--text-color)] mb-2">{{
      'graphs.sections.measuresAndPosts' | transloco
    }}</h3>
    <div class="flex gap-4 flex-wrap">
      @if (selectedMeasureX(); as measure) {
        <app-measure-chip
          [measure]="measure"
          (change)="addMeasureX.emit()"
          (configure)="configureMeasureX.emit()"
          (remove)="removeMeasureX.emit()" />
      } @else {
        <button
          type="button"
          (click)="addMeasureX.emit()"
          class="flex items-center gap-(--space-2) px-(--space-4) py-(--space-2) border-2 border-dashed border-[var(--border)] rounded-[var(--radius-md)] text-(color:--text-secondary) hover:border-(color:--p-primary-ui) hover:text-(--p-primary-text) transition-colors">
          <i class="pi pi-plus text-[var(--text-lg)]" aria-hidden="true"></i>
          <span>{{ 'common.accessibility.addMeasureX' | transloco }}</span>
        </button>
      }
      @if (selectedMeasureY(); as measure) {
        <app-measure-chip
          [measure]="measure"
          (change)="addMeasureY.emit()"
          (configure)="configureMeasureY.emit()"
          (remove)="removeMeasureY.emit()" />
      } @else {
        <button
          type="button"
          (click)="addMeasureY.emit()"
          class="flex items-center gap-(--space-2) px-(--space-4) py-(--space-2) border-2 border-dashed border-[var(--border)] rounded-[var(--radius-md)] text-(color:--text-secondary) hover:border-(color:--p-primary-ui) hover:text-(--p-primary-text) transition-colors">
          <i class="pi pi-plus text-[var(--text-lg)]" aria-hidden="true"></i>
          <span>{{ 'common.accessibility.addMeasureY' | transloco }}</span>
        </button>
      }
    </div>
  </div>
</div>
